import AUTH_TYPES from "../types/authTypes";

const initialState = {
  submitting: false,
  isAuthenticated: false,
  error: null,
  accessToken: null,
  refreshToken: null,
  tokenType: null,
  user: null,
  grades: [],
  availableRoles: [],
  schools: [],
  passcode: "",
  schoolSelectionEnabled: false,
  client: { name: "", imageUrl: "" },
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case AUTH_TYPES.RESET_STATE:
      return initialState;

    case AUTH_TYPES.RESET_FORMS:
      return { ...state, loading: false, error: null, submitting: false };

    case AUTH_TYPES.LOGIN_BEGIN:
      return {
        ...state,
        submitting: true,
        error: null,
        token: null,
      };

    case AUTH_TYPES.LOGIN_SUCCESS:
      return {
        ...state,
        submitting: false,
        isAuthenticated: true,
        roles: action.payload.roles,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        tokenType: action.payload.tokenType,
        user: {
          userId: action.payload.userId,
          email: action.payload.email,
        },
      };

    case AUTH_TYPES.LOGIN_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload.error,
      };

    case AUTH_TYPES.LOGOUT_BEGIN:
      return {
        ...state,
        submitting: true,
      };

    case AUTH_TYPES.LOGOUT_SUCCESS:
      return {
        ...state,
        submitting: false,
        isAuthenticated: false,
        token: null,
      };

    case AUTH_TYPES.LOGOUT_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload.error,
      };

    case AUTH_TYPES.SIGNUP_BEGIN:
      return {
        ...initialState,
        submitting: true,
        user: { name: action.payload.name },
      };

    case AUTH_TYPES.SIGNUP_SUCCESS:
      return {
        ...state,
        submitting: false,
        isAuthenticated: true,
        roles: action.payload.roles,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        tokenType: action.payload.tokenType,
        user: { ...state.user, ...action.payload },
      };

    case AUTH_TYPES.SIGNUP_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload.error,
      };

    case AUTH_TYPES.SET_PASSCODE:
      return {
        ...state,
        passcode: action.payload.passcode,
        schoolSelectionEnabled: action.payload.schoolSelectionEnabled,
      };
    case AUTH_TYPES.SEND_RESET_LINK_BEGIN:
      return {
        ...initialState,
        submitting: true,
      };

    case AUTH_TYPES.SEND_RESET_LINK_SUCCESS:
      return {
        ...state,
        submitting: false,
      };

    case AUTH_TYPES.SEND_RESET_LINK_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload.error,
      };

    case AUTH_TYPES.RESET_PASSWORD_BEGIN:
      return {
        ...initialState,
        submitting: true,
      };

    case AUTH_TYPES.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        submitting: false,
      };

    case AUTH_TYPES.RESET_PASSWORD_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload.error,
      };

    case AUTH_TYPES.FETCH_SCHOOLS_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case AUTH_TYPES.FETCH_SCHOOLS_SUCCESS:
      return {
        ...state,
        loading: false,
        schools: action.payload,
      };

    case AUTH_TYPES.FETCH_SCHOOLS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case AUTH_TYPES.FETCH_SCHOOLS_BY_PASSCODE_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case AUTH_TYPES.FETCH_SCHOOLS_BY_PASSCODE_SUCCESS:
      return {
        ...state,
        loading: false,
        schools: action.payload.schools,
        client: {
          name: action.payload.client.name,
          imageUrl: action.payload.imageUrl,
        },
      };

    case AUTH_TYPES.FETCH_SCHOOLS_BY_PASSCODE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case AUTH_TYPES.FETCH_ROLES_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case AUTH_TYPES.FETCH_ROLES_SUCCESS:
      return {
        ...state,
        loading: false,
        availableRoles: action.payload,
      };

    case AUTH_TYPES.FETCH_ROLES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case AUTH_TYPES.FETCH_GRADES_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case AUTH_TYPES.FETCH_GRADES_SUCCESS:
      return {
        ...state,
        loading: false,
        grades: action.payload,
      };

    case AUTH_TYPES.FETCH_GRADES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case AUTH_TYPES.CREATE_GROUP_BEGIN:
      return {
        ...state,
        submitting: true,
      };

    case AUTH_TYPES.CREATE_GROUP_SUCCESS:
      return {
        ...state,
        submitting: false,
      };

    case AUTH_TYPES.CREATE_GROUP_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload.error,
      };

    case AUTH_TYPES.FETCH_PROFILE_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case AUTH_TYPES.FETCH_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload.data,
      };

    case AUTH_TYPES.FETCH_PROFILE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case AUTH_TYPES.UPDATE_PROFILE_BEGIN:
      return {
        ...state,
        submitting: true,
      };

    case AUTH_TYPES.UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        submitting: false,
      };

    case AUTH_TYPES.UPDATE_PROFILE_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload.error,
      };

    default:
      return state;
  }
}
